import { Box, SxProps, Theme, Typography } from "@mui/material";
import { COLOR } from "../../utils/colors";

export default function EmptySection({
  title,
  description,
  sx,
  hideTitle,
  hideDescription
}: {
  title?: string;
  description?: string;
  sx?: SxProps<Theme>;
  hideTitle?: boolean;
  hideDescription?: boolean;
}) {
  return (
    <Box sx={{
      textAlign: "center",
      padding: "2rem",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0.5,
      color: COLOR.gray[500],
      ...sx
    }}>
      {!hideTitle && (
        <Typography
          variant="h6"
          sx={{
            color: COLOR.gray[600],
            fontWeight: 600,
            fontSize: '16px'
          }}
        >{title || 'No Data Found'}</Typography>
      )}
      {!hideDescription && (
        <Typography
          variant="body2"
          sx={{
            color: COLOR.gray[500],
            fontWeight: 400,
            fontSize: '14px'
          }}
        >
          {description || "There's nothing here yet."}
        </Typography>
      )}
    </Box>
  )
}